import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { Form, Input } from 'src/components/Antd';
// import { OriNumberInput } from 'src/components/Antd/NumberInput/NumberInput';
import { Select } from 'src/components/Antd/Select';
import {
  EnumFieldType,
  SelectorType,
  Type,
} from 'src/components/FieldModal/config';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
//import { useGetAreaCodeText } from 'src/hooks/useGetAreaCodeText';
import { useI18n } from 'src/hooks/useRouterChange';
import { hasValue, onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { responseHandler } from 'src/tools/server';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import { FiledNameKeyMapping, OptionKeyMapping } from '../../config';
import css from './css.module.less';
import {
  PhoneNumber,
  AreaCodeInfo,
  MobileNumberAreaInfo,
} from 'src/components/AreaCodeInfo';
import { getAreaCodeUuid } from 'src/tools/tools';

export enum ECustomType {
  MobileWithCode = 'MobileWithCode',
}
const formName = 'CustomerInfoModal';
const Item = Form.Item;
const Option = Select.Option;
const symbol = '++~~**~~++';
//const uuidSep = '===========';
// const generateUuid = (uuid1, uuid2) => {
//   return `${uuid1}${uuidSep}${uuid2}`;
// };
// const getUuids = (uuids) => {
//   return uuids.split(uuidSep);
// };
const generateKey = (type, selectorType, fieldType, name, uuid) => {
  return `${type}${symbol}${selectorType}${symbol}${fieldType}${symbol}${name}${symbol}${uuid}`;
};

enum ErrorCode {
  email = 119008,
  mobileNumber = 119009,
}

// enum GeneratorType {
//   Single = 'Single',
//   Multiple = 'Multiple',
//   DOB = 'DOB',
// }

const getDetails = (key) => {
  const [type, selectorType, fieldType, name, uuid] = key.split(symbol);
  return { type, selectorType, fieldType, name, uuid };
};

const CustomerInfoModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const extraRules = {
    [EnumFieldType.Email]: [
      {
        type: 'email',
        message: getI18n(`general.customerInfoModal-message`),
      },
    ],
  };

  const {
    fields: __field = [], // onCancel, onOk
    onConfirm,
    onCancel,
  } = props;
  const fields = __field.filter((i) => i.field);

  //专门给areaCode 和 mobile number 做优化 一定要这么做，不具有可扩展性
  const preProcessFields = React.useMemo(() => {
    return fields.map((i) => {
      const name = get(i, 'field.name') || [];
      const uuid = get(i, 'field.uuid') || [];
      const type = get(i, 'field.type');
      const selectorType = get(i, 'field.selectorType');
      const fieldType = get(i, 'field.fieldType');
      const kName = generateKey(type, selectorType, fieldType, name, uuid);
      return { ...i, kName };
    });
  }, [fields]);
  //console.log('iniValue', iniValue);
  //console.log('preProcessFields', preProcessFields);
  const mobileKey = React.useMemo(() => {
    const o =
      preProcessFields.find((i) => {
        const fieldType = get(i, 'field.fieldType');
        return fieldType === EnumFieldType.AreaCodeMobileNumber;
      }) || {};
    const key = get(o, 'kName');
    return key;
  }, [preProcessFields]);

  const mobileId = React.useMemo(() => {
    return `${formName}_${mobileKey}`;
  }, [mobileKey]);

  const emailKey = React.useMemo(() => {
    const o =
      preProcessFields.find((i) => {
        const fieldType = get(i, 'field.fieldType');
        return fieldType === EnumFieldType.Email;
      }) || {};
    const key = get(o, 'kName');
    return key;
  }, [preProcessFields]);
  const emailId = React.useMemo(() => {
    return `${formName}_${emailKey}`;
  }, [emailKey]);
  //  console.log('preProcessFields', preProcessFields);
  const options = useSelector(getAreaCodes());

  const iniValue = preProcessFields.reduce((pre, now) => {
    let value = null;
    const name = get(now, 'field.name') || [];
    const uuid = get(now, 'field.uuid') || [];
    const _v = get(now, 'value') || [];

    const type = get(now, 'field.type');
    const selectorType = get(now, 'field.selectorType');
    const fieldType = get(now, 'field.fieldType');
    //    const options = get(now, 'field.selectorOptions') || [];
    const defaultMobileNumber = options.filter((o) => o.defaultOption);

    // if (fieldType === ECustomType.MobileWithCode) {
    //   value = _v;
    // } else {
    if (fieldType === EnumFieldType.AreaCodeMobileNumber) {
      const [areaCodeInfoUuid, mobileNumber] = _v;
      value = {
        areaCodeInfo: {
          uuid: areaCodeInfoUuid || (defaultMobileNumber[0] || {}).uuid,
        },
        mobileNumber,
      };
    } else {
      if (type !== Type.Selector) {
        if (fieldType === EnumFieldType.DateOfBirth) {
          const y = _v[0];
          const m = _v[1];
          const d = _v[2];
          value = { y, m, d };
        } else {
          value = _v[0];
        }
      }
      if (type === Type.Selector) {
        if (selectorType === SelectorType.Multiple) {
          value = _v;
        } else {
          value = _v[0];
        }
      }
    }

    // }

    const k = generateKey(type, selectorType, fieldType, name, uuid);

    return { ...pre, [k]: value };
  }, {});

  const [form] = Form.useForm();
  const _formGenerator = (values) => {
    const _v = Object.keys(values).reduce((pre, now) => {
      const { type, selectorType, fieldType, uuid } = getDetails(now);
      let value = null;
      const currentV = values[now];
      if (fieldType === EnumFieldType.AreaCodeMobileNumber) {
        const mobileNumber = get(currentV, 'mobileNumber');
        const areaCodeInfo = get(currentV, 'areaCodeInfo');
        return [
          ...pre,
          {
            field: { uuid },
            value: [getAreaCodeUuid(areaCodeInfo), mobileNumber],
          },
        ];
      } else {
        if (type === Type.Selector) {
          if (selectorType === SelectorType.Multiple) {
            value = currentV;
          } else {
            if (hasValue(currentV)) {
              value = [currentV];
            } else {
              value = [];
            }
          }
        }
        if (type === Type.Input) {
          if (fieldType === EnumFieldType.DateOfBirth) {
            const d = get(currentV, 'd');
            const m = get(currentV, 'm');
            const y = get(currentV, 'y');
            const t = [y, m, d];
            value = t;
          } else {
            if (hasValue(currentV)) {
              value = [currentV];
            } else {
              value = [];
            }
          }
        }
      }

      return [
        ...pre,
        {
          field: { uuid },
          value,
        },
      ];
    }, []);
    return _v;
  };

  const mobileIsValid = (value) => {
    const { areaCodeInfo, mobileNumber } = value || {};
    const num = mobileNumber ? mobileNumber.toString() : null;
    const hasValue =
      (num && !getAreaCodeUuid(areaCodeInfo)) ||
      (!num && getAreaCodeUuid(areaCodeInfo));
    return hasValue;
  };

  const mobileHasValue = (value) => {
    const { areaCodeInfo, mobileNumber } = value || {};
    const num = mobileNumber ? mobileNumber.toString() : null;
    const hasValue = num && getAreaCodeUuid(areaCodeInfo);
    return hasValue;
  };

  const emailHasValue = (value) => {
    const hasValue = value;
    return hasValue;
  };

  const checkIsValidBeforeSubmit = () => {
    const email = form.getFieldValue(emailKey);
    const mobile = form.getFieldValue(mobileKey);
    const _e = emailHasValue(email);
    const _m = mobileHasValue(mobile);
    if (!_e && !_m) {
      form.setFields([
        {
          name: mobileKey,
          errors: [getI18n('general.customerInfoModal-fillin')],
        },
        {
          name: emailKey,
          errors: [getI18n('general.customerInfoModal-fillin')],
        },
      ]);
      timeoutScroll(emailId);
      return false;
    } else {
      return true;
    }
  };

  const handleOnFinish = (values) => {
    const data = _formGenerator(values);
    if (onConfirm) {
      const isValid = checkIsValidBeforeSubmit();
      if (isValid)
        onConfirm(data).then((res) => {
          const { response, cb } = res || {};
          const _response = responseHandler(response);
          const { success, data, errorCode, errMsg } = _response;
          if (success) {
            if (cb) {
              cb(data);
            }
            return;
          } else {
            if (errorCode == ErrorCode.email) {
              if (emailId) {
                form.setFields([{ name: emailKey, errors: [errMsg] }]);
                timeoutScroll(emailId);
                return;
              }
              //   { name: 'finish_date', errors: [] },
              //email
            }
            if (errorCode == ErrorCode.mobileNumber) {
              if (mobileId) {
                form.setFields([{ name: mobileKey, errors: [errMsg] }]);
                timeoutScroll(mobileId);
                return;
              }
              //mobile
            }
            modal.error({
              title: getI18n('general.requestError'),
              content:
                errMsg || getI18n('general.systemError,PleaseContactAdmin'),
              onCancel: () => {
                console.error('errMsg:', errMsg);
              },
              onCancelText: getI18n('general.antd.Uploader.ok'),
            });
            return;
          }
          //119008 email  code-400 119009-phone number
        });
    }
  };
  React.useEffect(() => {
    form.setFieldsValue(iniValue);
  }, [iniValue]);
  return (
    <React.Fragment>
      <div className={css.container}>
        <Form
          form={form}
          name={formName}
          //initialValues={iniValue}
          onFinishFailed={(error) => {
            onFinishFailed(formName, error);
          }}
          onFinish={handleOnFinish}>
          {preProcessFields.map((i) => {
            const name = get(i, 'field.name') || [];
            const i18nKey = FiledNameKeyMapping[name];
            const title = getI18n(i18nKey);
            const uuid = get(i, 'field.uuid') || [];
            const type = get(i, 'field.type');
            const selectorType = get(i, 'field.selectorType');
            const fieldType = get(i, 'field.fieldType');
            // const options = get(i, 'field.selectorOptions') || [];
            const k = get(i, 'kName') || [];
            const defaultMobileNumber = options.filter((o) => o.defaultOption);

            // const k = generateKey(type, selectorType, fieldType, name, uuid);

            const child = () => {
              // if (!fieldType) {
              //   return null;
              // }
              if (fieldType === EnumFieldType.AreaCodeMobileNumber) {
                return (
                  <ItemWrapper title={title}>
                    <Item
                      shouldUpdate={(p, c) => {
                        const epV = get(p, emailKey);
                        const ecV = get(c, emailKey);
                        const mpV = get(p, mobileKey);
                        const mcV = get(c, mobileKey);
                        return epV !== ecV || mpV !== mcV;
                      }}>
                      {({ getFieldValue }) => {
                        // const emailData = getFieldValue(emailKey);
                        // const emailIsValid = emailHasValue(emailData);
                        setTimeout(() => {
                          form.validateFields([emailKey]);
                        });
                        return (
                          <Item
                            name={k}
                            initialValue={{
                              areaCodeInfo: {
                                uuid: (defaultMobileNumber[0] || {}).value,
                              },
                            }}
                            rules={[
                              {
                                validator: async (x, value) => {
                                  const isMobileNumberValid =
                                    mobileIsValid(value);
                                  // const isMobileHasValue =
                                  //   mobileHasValue(value);
                                  const text = getI18n(
                                    'general.customerInfoModal-fillwithcode',
                                  );
                                  if (isMobileNumberValid) {
                                    return Promise.reject(
                                      new Error(
                                        text,
                                        // getI18n(
                                        //   'allOrders.orderDetail.component_customer_editrecipientinfo_error',
                                        // ),
                                      ),
                                    );
                                  }
                                },
                              },
                            ]}>
                            <MobileNumberAreaInfo />
                          </Item>
                        );
                      }}
                    </Item>
                  </ItemWrapper>
                );
              } else if (fieldType === EnumFieldType.Email) {
                return (
                  <ItemWrapper title={title}>
                    <Item
                      shouldUpdate={(p, c) => {
                        const epV = get(p, emailKey);
                        const ecV = get(c, emailKey);
                        const mpV = get(p, mobileKey);
                        const mcV = get(c, mobileKey);
                        return epV !== ecV || mpV !== mcV;
                      }}>
                      {({ getFieldValue }) => {
                        // const mobileData = getFieldValue(mobileKey);
                        // const mobileHasValue = emailHasValue(mobileData);
                        setTimeout(() => {
                          form.validateFields([mobileKey]);
                        });
                        return (
                          <Input
                            formProps={{
                              name: k,
                              rules: [
                                {
                                  type: 'email',
                                  message: getI18n(
                                    'general.customerInfoModal-message',
                                  ),
                                },
                              ],
                            }}
                            size='large'
                            maxLength={200}
                          />
                        );
                      }}
                    </Item>
                  </ItemWrapper>
                );
              } else {
                if (type === Type.Input) {
                  if (fieldType === EnumFieldType.DateOfBirth) {
                    return (
                      <ItemWrapper title={title}>
                        <Item
                          name={k}
                          rules={[
                            {
                              validator: async (_, value) => {
                                const { y, m, d } = value || {};

                                const hasYear = hasValue(y) && y !== '';
                                const hasMonth = hasValue(m) && m !== '';
                                const hasDay = hasValue(d) && d !== '';

                                const error = new Error(
                                  getI18n('general.customerInfoModal-filldob'),
                                );

                                if (hasYear && !/^\d{4}$/.test(y)) {
                                  return Promise.reject(error);
                                }

                                if (hasMonth) {
                                  const monthNum = Number(m);
                                  if (
                                    !/^\d{1,2}$/.test(m) ||
                                    monthNum < 1 ||
                                    monthNum > 12
                                  ) {
                                    return Promise.reject(error);
                                  }
                                }

                                if (hasDay) {
                                  const dayNum = Number(d);
                                  if (
                                    !hasMonth ||
                                    !/^\d{1,2}$/.test(d) ||
                                    dayNum < 1 ||
                                    dayNum > 31
                                  ) {
                                    return Promise.reject(error);
                                  }
                                }

                                return Promise.resolve();
                              },
                            },
                          ]}>
                          <DOBForm />
                        </Item>
                      </ItemWrapper>
                    );
                  }

                  return (
                    <ItemWrapper title={title}>
                      <Input
                        formProps={{
                          name: k,
                          rules: extraRules[fieldType] || [],
                        }}
                        size='large'
                        maxLength={200}
                      />
                    </ItemWrapper>
                  );
                }
                if (type === Type.Selector) {
                  const options = get(i, 'field.selectorOptions') || [];
                  const Options = options.map((i, index) => {
                    const { value, label } = i;
                    const optionI18nKey = OptionKeyMapping[label];
                    const _lable = optionI18nKey
                      ? getI18n(optionI18nKey)
                      : label;
                    return (
                      <Option value={value} key={index}>
                        {_lable}
                      </Option>
                    );
                  });
                  if (selectorType === SelectorType.Multiple) {
                    return (
                      <ItemWrapper title={title}>
                        <Item name={k}>
                          <Select mode='multiple' size='large'>
                            {Options}
                          </Select>
                        </Item>
                      </ItemWrapper>
                    );
                  } else {
                    return (
                      <ItemWrapper title={title}>
                        <Item name={k}>
                          <Select size='large'>{Options}</Select>
                        </Item>
                      </ItemWrapper>
                    );
                  }
                }
              }

              return null;
            };
            return <React.Fragment key={uuid}>{child()}</React.Fragment>;
          })}
        </Form>
      </div>
      <ModalFooter
        okText={getI18n('general.confirm')}
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
      />
    </React.Fragment>
  );
};
export default CustomerInfoModal;
const DOBForm = (props) => {
  const { value, onChange, id } = props;
  const { y, m, d } = value || {};
  const [year, setYear] = React.useState(y);
  const [month, setMonth] = React.useState(m);
  const [day, setDay] = React.useState(d);
  React.useEffect(() => {
    if (year !== y) {
      setYear(y);
    }
    if (month !== m) {
      setMonth(m);
    }
    if (day !== d) {
      setDay(d);
    }
  }, [value]);
  const handleOnYearChange = (e) => {
    setYear(e);
    if (onChange) {
      onChange({
        y: e,
        m: month,
        d: day,
      });
    }
  };
  const handleOnMonthChange = (e) => {
    setMonth(e);
    if (onChange) {
      onChange({
        y: year,
        m: e,
        d: day,
      });
    }
  };
  const handleOnDateChange = (e) => {
    setDay(e);
    if (onChange) {
      onChange({
        y: year,
        m: month,
        d: e,
      });
    }
  };
  return (
    <div className={css.dobContainer} id={id}>
      <Input
        onChange={handleOnYearChange}
        value={year}
        placeholder='yyyy' //要求修改https://cathaydigital.atlassian.net/browse/UXPSA-11945
        className={css.dobInput}
        size='large'
      />
      <div className={css.intervalBlock} />
      <Input
        onChange={handleOnMonthChange}
        placeholder='mm'
        className={css.dobInput}
        size='large'
        value={month}
      />
      <div className={css.intervalBlock} />
      <Input
        onChange={handleOnDateChange}
        placeholder='dd' //要求修改https://cathaydigital.atlassian.net/browse/UXPSA-11945
        className={css.dobInput}
        size='large'
        value={day}
      />
    </div>
  );
};

export {
  //AreaCode,
  AreaCodeInfo,
  MobileNumberAreaInfo,
  PhoneNumber,
};
